// ui/LoadingContext.tsx
import React, { createContext, useContext, useState } from "react";

type LoadingContextType = {
  loading: boolean;
  startLoading: () => void;
  stopLoading: () => void;
};

const LoadingContext = createContext<LoadingContextType | undefined>(undefined);

let loadingCount = 0;
let startLoading: (() => void) | null = null;
let stopLoading: (() => void) | null = null;

export function registerLoadingHandlers(
  start: () => void,
  stop: () => void
) {
  startLoading = start;
  stopLoading = stop;
}

export function beginLoading() {
  loadingCount++;
  if (loadingCount === 1) {
    startLoading?.();
  }
}

export function endLoading() {
  loadingCount = Math.max(0, loadingCount - 1);
  if (loadingCount === 0) {
    stopLoading?.();
  }
}

export const LoadingProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [loading, setLoading] = useState(false);

  return (
    <LoadingContext.Provider
      value={{
        loading,
        startLoading: () => setLoading(true),
        stopLoading: () => setLoading(false),
      }}
    >
      {children}
    </LoadingContext.Provider>
  );
};

export function useLoading() {
  const ctx = useContext(LoadingContext);
  if (!ctx) {
    throw new Error("useLoading must be used within LoadingProvider");
  }
  return ctx;
}
